import { useRef, type MouseEvent, type ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Point, type Canvas } from 'fabric';
import { useToolContext } from '@/context/ToolContext';

import Button from '@/components/Button/Button';

interface QuickMenuProps {
  children: ReactNode;
}

const QuickMenu = ({ children }: QuickMenuProps) => {
  const quickMenuRef = useRef<HTMLDivElement>(null);
  const ToolContextState = useToolContext();
  const t = useTranslations();

  const openItemMenu = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    ToolContextState?.setIsMenuActive(true);
  };
  const resetZoom = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const canvas: Canvas = ToolContextState.canvasStateRef.current;
    const point = new Point(canvas.width / 2, canvas.height / 2);
    canvas.zoomToPoint(point, 1);
    canvas.absolutePan(new Point(0, 0));
    ToolContextState.setEnableResetButton(false);
  };

  return (
    <div
      ref={quickMenuRef}
      className={`QuickMenu ${ToolContextState?.selection ? '' : 'QuickMenu-show'}`}
    >
      <div className="QuickMenu-inner">
        {children}
        <Button
          clickEvent={openItemMenu}
          ariaLabel={t('DRWNG__A11Y_OPEN_MENU')}
        >
          <svg
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path fill="#FFF" stroke="#FFF" d="M8.75.75h2.5v18.5h-2.5z" />
            <path fill="#FFF" stroke="#FFF" d="M19.25 8.75v2.5H.75v-2.5z" />
          </svg>
        </Button>
        {ToolContextState.enableResetButton && (
          <Button
            clickEvent={resetZoom}
            modifier="Button--reset"
            ariaLabel={t('DRWNG__A11Y_RESET_ZOOM')}
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.132 12.867 2 9 2C5.132 2 2 5.132 2 9C2 12.867 5.132 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875V13.875ZM5 8H13V10H5V8Z"
                fill="#253780"
              />
            </svg>
          </Button>
        )}
      </div>
    </div>
  );
};

export default QuickMenu;
